import { faCalendar, faCheck, faDollarSign, faFile, faHashtag, faKeyboard, faList, faPhone, faPlus, faTimes, faUser, faUserCog } from '@fortawesome/free-solid-svg-icons';
const { FontAwesomeIcon } = require("@fortawesome/react-fontawesome");

export const InputFieldIcon = [
    {
        label: "TEXT",
        value: "TEXT",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faKeyboard} /></>
    },
    {
        label: "PICKLIST",
        value: "PICKLIST",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faList} /></>
    },
    {
        label: "USER",
        value: "USER",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faUser} /></>
    },
    {
        label: "MULTI-PICKLIST",
        value: "MULTI-PICKLIST",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faList} /></>
    },
    {
        label: "NUMBER",
        value: "NUMBER",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faHashtag} /></>
    },
    {
        label: "CURRENCY",
        value: "CURRENCY",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faDollarSign} /></>
    },
    {
        label: "DATE",
        value: "DATE",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faCalendar} /></>
    },
    {
        label: "PHONE",
        value: "PHONE",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faPhone} /></>
    },
    {
        label: "CHECKBOX",
        value: "CHECKBOX",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faCheck} /></>
    },
    {
        label: "ATTACHMENT",
        value: "ATTACHMENT",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faFile} /></>
    },
    {
        label: "ROLE",
        value: "ROLE",
        icon: <><FontAwesomeIcon className='ml-1 mr-1' icon={faUserCog} /></>
    },
];